(() => {
  'use strict';

  const items = [...document.querySelectorAll('.cart-item')];
  if (!items.length) return;

  const giftItems = items.filter((item) => item.querySelector('.cart-item-title')?.textContent?.trim() === 'Give a Sassy Hive Adventure');
  if (!giftItems.length) return;

  const taxNote = document.querySelector('.cart-tax-note');
  const policyReminder = document.querySelector('.cart-policy-reminder');
  const reassurance = document.querySelector('.cart-reassurance');
  const allGiftCards = giftItems.length === items.length;

  if (allGiftCards) {
    if (taxNote) taxNote.textContent = 'Digital gift cards are delivered electronically after payment. No physical gift card is mailed and no shipping charge applies to the gift card itself.';
    if (policyReminder) policyReminder.hidden = true;
    if (reassurance) reassurance.innerHTML = '<span>♡ Digital delivery</span><span>✉️ Recipient gifting</span><span>🔒 Secure checkout</span>';
    return;
  }

  if (taxNote && !document.querySelector('[data-gift-card-cart-note]')) {
    const note = document.createElement('p');
    note.className = 'notice';
    note.dataset.giftCardCartNote = 'true';
    note.innerHTML = '<strong>Gift card delivery:</strong> Gift cards in this order are electronic and are not part of the 2–4 week physical-order preparation window.';
    taxNote.before(note);
  }
})();
